<template lang="pug">
#analiseSocioambiental
    .row
        .col-12
            mapa(
                v-if='layersMaps',
                :mapLayersConfigs='layersMaps',
                :mapConfig='mapConfig',
                :locked='true',
                :height='"230px"',
                :idMapa='"mapaAnaliseSocioAmbiental"'
            )
    .row
        .col-12.collapse-restricao
            collapse-restricao#AREAS_EMBARGADAS_IBAMA(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA',
                :showLabelRestricao='true'
            )
                area-embargada-ibama(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#LISTA_AREA_EMBARGADA(
                :tipoRestricao='tipoRestricoes.LISTA_AREA_EMBARGADA',
                :showLabelRestricao='true'
            )
                area-embargada-ibama-lista(
                    :areaEmbargada='tipoRestricoes.LISTA_AREA_EMBARGADA',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_ICMBIO(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_ICMBIO',
                :showLabelRestricao='true'
            )
                area-embargada-icmbio(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_ICMBIO',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_SEMA_MT(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_SEMA_MT',
                :showLabelRestricao='true'
            )
                area-embargada-sema-mt(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_SEMA_MT',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AREA_EMBARGADA_GOIAS(
                :tipoRestricao='tipoRestricoes.AREA_EMBARGADA_GOIAS',
                :showLabelRestricao='true'
            )
                area-embargada-goias(
                    :areaEmbargada='tipoRestricoes.AREA_EMBARGADA_GOIAS',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#LDI(
                :tipoRestricao='tipoRestricoes.LDI',
                :showLabelRestricao='true'
            )
                ldi(
                    :dados='tipoRestricoes.LDI',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#MORATORIA_SOJA(
                :tipoRestricao='tipoRestricoes.MORATORIA_SOJA',
                :showLabelRestricao='true'
            )
                moratoria-soja(
                    :dados='tipoRestricoes.MORATORIA_SOJA',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#MORATORIA_SOJA_PONTOS(
                :tipoRestricao='tipoRestricoes.MORATORIA_SOJA_PONTOS',
                :showLabelRestricao='true'
            )
                moratoria-soja-pontos(
                    :dados='tipoRestricoes.MORATORIA_SOJA_PONTOS',
                    slot='restricao'
                )

            collapse-restricao#TERRAS_INDIGENAS(
                :tipoRestricao='tipoRestricoes.TERRA_INDIGENA',
                :showLabelRestricao='true'
            )
                terras-indigenas(
                    :terrasIndigenas='tipoRestricoes.TERRA_INDIGENA',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#LISTA_SUJA_TRABALHO_ESCRAVO(
                :tipoRestricao='tipoRestricoes.LISTA_SUJA_TRABALHO_ESCRAVO',
                :showLabelRestricao='true',
                mensagemResultadoVazio='Não foram detectadas irregularidades.'
            )
                trabalho-escravo(
                    :trabalhoEscravo='tipoRestricoes.LISTA_SUJA_TRABALHO_ESCRAVO',
                    slot='restricao'
                )

            collapse-restricao#UNIDADES_CONSERVACAO(
                :tipoRestricao='tipoRestricoes.UNIDADE_CONSERVACAO',
                :mensagemResultadoVazio='msgUnidadeConservacao'
            )
                unidades-conservacao(
                    :unidadesConservacao='tipoRestricoes.UNIDADE_CONSERVACAO',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#PRODES(
                :tipoRestricao='tipoRestricoes.PRODES',
                :mensagemResultadoVazio='msgPRODES'
            )
                prodes(
                    :prodes='tipoRestricoes.PRODES',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#AMAZONIA_PROTEGE(
                :tipoRestricao='tipoRestricoes.AMAZONIA_PROTEGE',
                :showLabelRestricao='true'
            )
                amazonia-protege(
                    :amazoniaProtege='tipoRestricoes.AMAZONIA_PROTEGE',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#POVOS_COMUNIDADES_TRADICIONAIS(
                :tipoRestricao='tipoRestricoes.POVOS_COMUNIDADES_TRADICIONAIS',
                :showLabelRestricao='true'
            )
                povos-comunidades-tradicionais(
                    :dados='tipoRestricoes.POVOS_COMUNIDADES_TRADICIONAIS',
                    :geometriaAreaMonitorada='dadosAreaMonitorada.geometria',
                    slot='restricao'
                )

            collapse-restricao#PROTOCOLO_VERDE_GRAOS(
                :tipoRestricao='tipoRestricoes.PROTOCOLO_VERDE_GRAOS',
                :showLabelRestricao='true'
            )
                protocolo-verde-graos(
                    :dados='tipoRestricoes.PROTOCOLO_VERDE_GRAOS',
                    slot='restricao'
                )
</template>

<script>
import CollapseRestricao from '../CollapseRestricao';
import AmazoniaProtege from './restricoes/AmazoniaProtege';
import AreaEmbargadaIbama from './restricoes/AreaEmbargadaIbama';
import AreaEmbargadaIcmbio from './restricoes/AreaEmbargadaIcmbio';
import AreaEmbargadaSemaMt from './restricoes/AreaEmbargadaSemaMt';
import MoratoriaSoja from './restricoes/MoratoriaSoja';
import Ldi from './restricoes/LDI';
import PovosComunidadesTradicionais from './restricoes/PovosComunidadesTradicionais';
import TerrasIndigenas from './restricoes/TerrasIndigenas';
import TrabalhoEscravo from './restricoes/TrabalhoEscravo';
import UnidadesConservacao from './restricoes/UnidadesConservacao';
import Prodes from './restricoes/PRODES';
import AreaEmbargadaIbamaLista from './restricoes/AreaEmbargadaIbamaLista';
import AreaEmbagadaGoias from './restricoes/AreaEmbagadaGoias';
import ProtocoloVerdeGraos from './restricoes/ProtocoloVerdeGraos';
import MoratoriaSojaLista from './restricoes/MoratoriaSojaLista';

import AreasMonitoradasService from '@/services/AreasMonitoradasService';

import Mapa from '../../components/MapaLeaflet';
import LayerStyle from '../../utils/layerStyles';

export default {
    name: 'AnaliseSocioAmbiental',

    components: {
        Prodes,
        UnidadesConservacao,
        TrabalhoEscravo,
        TerrasIndigenas,
        AreaEmbargadaIbama,
        AreaEmbargadaIcmbio,
        AreaEmbargadaSemaMt,
        MoratoriaSoja,
        Ldi,
        PovosComunidadesTradicionais,
        AmazoniaProtege,
        AreaEmbargadaIbamaLista,
        AreaEmbagadaGoias,
        ProtocoloVerdeGraos,
        MoratoriaSojaLista,
        CollapseRestricao,
        Mapa
    },

    props: {
        dadosAreaMonitorada: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            imovel: {
                status: {
                    codigo: 'INCONFORMIDADES_ENCONTRADAS'
                }
            },
            msgPRODES:
                'Não foram detectadas sobreposições ou a soma das áreas sobrepostas não ultrapassa os 25 ha de tolerância.',
            msgUnidadeConservacao:
                'Não foram detectadas sobreposições com unidades de conservação de proteção integral.',
            tipoRestricoes: {
                AREA_EMBARGADA: {
                    nome: 'Áreas embargadas - IBAMA',
                    restricoes: [],
                    fonte: {}
                },
                LISTA_AREA_EMBARGADA: {
                    nome: 'Áreas embargadas (Lista) - IBAMA',
                    restricoes: [],
                    fonte: {}
                },
                TERRA_INDIGENA: {
                    nome: 'Terras indígenas',
                    restricoes: [],
                    fonte: {}
                },
                LISTA_SUJA_TRABALHO_ESCRAVO: {
                    nome: 'Lista de trabalho escravo (Ministério do Trabalho)',
                    restricoes: [],
                    fonte: {}
                },
                UNIDADE_CONSERVACAO: {
                    nome: 'Unidades de conservação',
                    restricoes: [],
                    fonte: {}
                },
                PRODES: {
                    nome: 'PRODES Amazônia Legal',
                    restricoes: [],
                    fonte: {}
                },
                AMAZONIA_PROTEGE: {
                    nome: 'Amazônia Protege',
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_ICMBIO: {
                    nome: 'Áreas embargadas - ICMBIO',
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_SEMA_MT: {
                    nome: 'Áreas embargadas - Sema - MT',
                    restricoes: [],
                    fonte: {}
                },
                AREA_EMBARGADA_GOIAS: {
                    nome: 'Áreas embargadas - GO',
                    restricoes: [],
                    fonte: {}
                },
                LDI: {
                    nome: 'Áreas Embargadas - LDI',
                    restricoes: [],
                    fonte: {}
                },
                MORATORIA_SOJA: {
                    nome: 'Moratória da Soja',
                    restricoes: [],
                    fonte: {}
                },
                MORATORIA_SOJA_PONTOS: {
                    nome: 'Moratória da Soja (Lista)',
                    restricoes: [],
                    fonte: {}
                },
                PROTOCOLO_VERDE_GRAOS: {
                    nome: 'Protocolo Verde dos Grãos',
                    restricoes: [],
                    fonte: {}
                },
                POVOS_COMUNIDADES_TRADICIONAIS: {
                    nome: 'Povos e Comunidades Tradicionais',
                    restricoes: [],
                    fonte: {}
                }
            },
            layersMaps: null,

            mapConfig: {
                controls: {
                    zoomControl: true
                }
            }
        };
    },
    mounted() {
        AreasMonitoradasService.analiseSocioambiental(
            this.dadosAreaMonitorada.id
        ).then(results => {
            results.data.forEach(result => {
                let tipoRestricao = this.tipoRestricoes[result.camada.codigo];
                if (tipoRestricao) {
                    tipoRestricao.restricoes = result.resultados;
                    tipoRestricao.fonte = result.camada.fonte;
                }
            });
        });

        this.configureLayersMapa();
    },

    methods: {
        configureLayersMapa() {
            this.layersMaps = [];

            let layerAreaMonitorada = {
                style: LayerStyle.AREA_MONITORADA(),
                name: 'Área Monitorada',
                geoJson: this.dadosAreaMonitorada.geometria
            };

            this.layersMaps.push(layerAreaMonitorada);

            if (
                this.dadosAreaMonitorada.dadosMonitoramento &&
                this.dadosAreaMonitorada.dadosMonitoramento
                    .geometriaAreaPlantada
            ) {
                let layerAreaMonitorada = {
                    style: LayerStyle.AREA_PLANTADA(),
                    name: 'Área plantada',
                    geoJson:
                        this.dadosAreaMonitorada.dadosMonitoramento
                            .geometriaAreaPlantada,
                    tooltip: `Área plantada ${this.dadosAreaMonitorada.dadosMonitoramento.areaPlantadaHa} ha`
                };

                this.layersMaps.push(layerAreaMonitorada);
            }

            this.dadosAreaMonitorada.dadosMonitoramento.dadosCulturasIdentificadas.forEach(
                dadoCultura => {
                    let culturaIdentificada =
                        dadoCultura.culturaIdentificada || {
                            nome: 'Não identificada',
                            codigo: 'NAO_IDENTIFICADA'
                        };
                    const estilo = culturaIdentificada
                        ? LayerStyle[culturaIdentificada.codigo]()
                        : LayerStyle.RESTRICAO();

                    let layerCulturaIdentificada = {
                        style: estilo,
                        name: culturaIdentificada.nome,
                        geoJson: dadoCultura.geometriaCulturaIdentificada,
                        tooltip: `Área plantada de ${culturaIdentificada.nome} - ${dadoCultura.areaCulturaIdentificadaHa} ha`
                    };

                    this.layersMaps.push(layerCulturaIdentificada);
                }
            );
        }
    }
};
</script>

<style lang="scss" scoped>
#analiseSocioambiental {
    .mapa {
        height: 200px;
        background-color: var(--gray);
    }

    .collapse-restricao {
        margin-top: 20px;
    }
}
</style>
